import gql from 'graphql-tag';

import type { RecomposeRequest } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationPromoteLowerScoringVariationsArgs } from 'src/types/backend';

import { FRAGMENT_RECOMPOSE_REQUEST } from './schema';

const MUTATION = gql`
  mutation PromoteLowerScoringVariations($recomposeRequestId: ID!) {
    promoteLowerScoringVariations(recomposeRequestId: $recomposeRequestId) {
      ...RecomposeRequest
    }
  }
  ${FRAGMENT_RECOMPOSE_REQUEST}
`;

type Variables = BackendMutationPromoteLowerScoringVariationsArgs;
type Result = RecomposeRequest;

export const promoteLowerScoringVariations = async (variables: Variables) => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });

  return getSingleProp<Result>(response.data);
};
